export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.Swal === 'undefined') {
      return
    }
    document.querySelectorAll('.js-swal').forEach((el) => {
      let opts = JSON.parse(el.dataset.swal || '{}')
      if (el.dataset.redirect) {
        // eslint-disable-next-line no-undef
        Swal.fire(opts).then(() => {
          window.location.href = el.dataset.redirect
        })
      }
      if (el.href) {
        el.addEventListener('click', () => {
          // eslint-disable-next-line no-undef
          Swal.fire(opts).then(() => {
            window.location.href = el.href
          })
          return false
        })
      }
    })
  })
})()
